export default function (callback) {
	const oldPush = window.nfForms.push;
	window.nfForms.push = function (item) {
		if (this !== window.nfForms) {
			// silently skipping
			return oldPush.call(this, item);
		}
		// Validate if an incoming object belongs to forms
		if (!item || !item.id || !item.settings || !item.fields) {
			window.console.log('Unable to recognize form object, skipping', item);
			return oldPush.call(this, item);
		}
		return oldPush.call(
			this,
			callback.call(this, item),
		);
	};
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/nfFormsPushInterceptor.js